import React from "react";
import Footer from "./Footer"; // Make sure the path is correct

export default function DashboardLayout({ sidebar, header, children }) {
  return (
    <div style={styles.app}>
      {/* SIDEBAR (NON-SCROLLABLE) */}
      {sidebar}

      {/* MAIN AREA */}
      <div style={styles.main}>
        {/* HEADER (NON-SCROLLABLE) */}
        {header}

        {/* SCROLLABLE CONTENT AREA */}
        <div style={styles.content}>
          <div style={styles.contentInner}>
            {children}
          </div>
        </div>
        
        {/* FULL WIDTH RUNNING FOOTER */}
        <Footer />
      </div>
    </div>
  );
}

const styles = {
  app: {
    display: "flex",
    height: "100vh",
    width: "100vw",
    background: "#0b0b0b",
    color: "#eaeaea",
    overflow: "hidden"
  },
  main: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    position: "relative"
  },
  content: {
    flex: 1,
    overflowY: "auto",
    padding: "32px",
    /* Add padding at the bottom so content doesn't get cut off by the fixed footer */
    paddingBottom: "80px" 
  },
  contentInner: {
    maxWidth: "1600px",
    margin: "0 auto",
    width: "100%"
  }
};